import { css, polished } from 'jimu-core';
import { colorUtils, hoverFocus } from 'jimu-theme';
function listGroupItemBariant(bg, color, activeColor) {
    return css `
    color: ${color};
    background-color: ${bg};

    &.list-group-item-action {
      ${hoverFocus(`
        color: ${color};
        background-color: ${polished.darken(0.05, bg)};
      `)}

      &.active {
        color: ${activeColor};
        background-color: ${color};
        border-color: ${color};
      }
    }
  `;
}
export const listGroupItemStyles = (props) => {
    var _a;
    const isAction = props.action;
    const propColor = props.color;
    const color = propColor === 'danger' ? 'error' : propColor;
    const theme = props.theme;
    const listGroupVars = (_a = theme === null || theme === void 0 ? void 0 : theme.components) === null || _a === void 0 ? void 0 : _a.listGroup;
    const themeColorLevel = (color, level = 0) => {
        const colorBase = level > 0 ? theme.ref.palette.black : theme.ref.palette.white;
        level = Math.abs(level);
        return polished.mix(level * 0.08, colorBase, color);
    };
    return listGroupVars && css `
    ${isAction && css `
      width: 100%;
      color: ${listGroupVars.action.color};
      text-align: inherit;

      ${hoverFocus(`
        color: ${listGroupVars.action.hover.color};
        text-decoration: none;
        background-color: ${listGroupVars.hover.bg};
      `)}

      &:active {
        color: ${listGroupVars.action.active.color};
        background-color: ${listGroupVars.action.active.bg};
      }
    `}

    position: relative;
    display: block;
    padding: ${listGroupVars.item.paddingY} ${listGroupVars.item.paddingX};
    margin-bottom: -${listGroupVars.border.width};
    background-color: ${listGroupVars.bg};
    border: ${listGroupVars.border.width} solid ${listGroupVars.border.color};

    &:first-of-type {
      ${polished.borderRadius('top', listGroupVars.borderRadius)};
    }

    &:last-of-type {
      margin-bottom: 0;
      ${polished.borderRadius('bottom', listGroupVars.borderRadius)};
    }

    ${hoverFocus(`
      z-index: 1;
      text-decoration: none;
    `)}

    &.disabled,
    &:disabled {
      color: ${listGroupVars.disabled.color};
      background-color: ${listGroupVars.disabled.bg};
    }

    &.active {
      z-index: 2;
      color: ${listGroupVars.active.color};
      background-color: ${listGroupVars.active.bg};
      border-color: ${listGroupVars.active.borderColor};
    }

    ${color && listGroupItemBariant(themeColorLevel(colorUtils.getThemeColorNameColor(color, theme), -9), themeColorLevel(colorUtils.getThemeColorNameColor(color, theme), 6), theme.ref.palette.white)}

  `;
};
